import Box from '@mui/material/Box'
import React from 'react'

import ExceptionIcon from 'components/exceptions/ExceptionIcon'
import { HHFormSelectField } from 'components/form-fields/v5'
import T from 'T'

import { EXCEPTION_FORM_FIELD, EXCEPTION_TYPE_OPTIONS } from './constants'

import type { ExceptionFormValues } from './constants'
import type { HHFormSelectOption } from 'components/form-fields/v5/HHFormSelectField'
import type { Control } from 'react-hook-form'

// "Exception type" selector. Options come from the registry (in sync with the backend enum).
type ExceptionTypeSelectProps = {
  control: Control<ExceptionFormValues>
}

// Render the type glyph next to the label in both the dropdown options and the selected value.
const renderOptionLabel = (option: HHFormSelectOption) => (
  <Box component="span" sx={{ alignItems: 'center', display: 'inline-flex', gap: 1 }}>
    <ExceptionIcon exception={String(option.value ?? '')} sx={{ fontSize: 18 }} />
    {option.label}
  </Box>
)

const ExceptionTypeSelect: React.FC<ExceptionTypeSelectProps> = ({ control }) => (
  <HHFormSelectField
    fullWidth
    control={control}
    getOptionLabel={renderOptionLabel}
    label={T.EXCEPTION_TYPE}
    name={EXCEPTION_FORM_FIELD.EXCEPTION_TYPE}
    options={EXCEPTION_TYPE_OPTIONS}
  />
)

export default ExceptionTypeSelect
